import { Photo } from '@types';
import { formatLocation, formatPhotoName } from '@utils/formatters';

export const AuthorMeta = () => (
  <>
    <meta itemProp="name" content="Marc Malignan" />
    <meta itemProp="birthDate" content="1989/07/17" />
    <meta itemProp="address" content="Paris, France" />
    <meta itemProp="email" content="contact@marcmalignan.com" />
  </>
);

export const PhotoMeta = ({ photo }: { photo: Photo }) => (
  <span className="hidden">
    <span itemProp="author" itemScope itemType="https://schema.org/Person">
      <AuthorMeta />
    </span>
    <meta itemProp="name" content={formatPhotoName(photo)} />
    <meta
      itemProp="contentLocation"
      content={
        typeof photo.location === 'string'
          ? photo.location
          : formatLocation(photo.location)
      }
    />
    <meta
      itemProp="image"
      content={`https://marcmalignan.com/img/${photo.id}.jpg`}
    />
    <meta itemProp="dateCreated" content={photo.date} />
  </span>
);
